import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

type Comment = {
  id: string;
  body: string;
  author_initials: string;
  created_at: string;
  is_owner: boolean;
};

export default function CommentList({
  threadId,
  currentUserId,
}: {
  threadId: string;
  currentUserId: string | null;
}) {
  const [comments, setComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data, error } = await supabase.rpc("feedback_comments_by_thread", {
      p_thread_id: threadId,
    });
    if (error) {
      console.error("❌ Kommentare laden fehlgeschlagen:", error.message);
      setComments([]);
    } else {
      setComments(data ?? []);
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threadId]);

  const deleteComment = async (id: string) => {
    if (!window.confirm("Kommentar wirklich löschen?")) return;
    const { error } = await supabase.from("feedback_comments").delete().eq("id", id);
    if (error) {
      console.error("❌ Löschen fehlgeschlagen:", error.message);
      alert("Kommentar konnte nicht gelöscht werden.");
    } else {
      setComments((prev) => prev.filter((c) => c.id !== id));
    }
  };

  if (loading) return <p>⏳ Lade Kommentare…</p>;
  if (comments.length === 0) return <p className="text-gray-500">Noch keine Kommentare.</p>;

  return (
    <div className="space-y-4">
      {comments.map((c) => (
        <div
          key={c.id}
          className="bg-gray-50 border rounded-lg p-3 flex justify-between items-start"
        >
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-gray-800 text-white text-xs">
                {c.author_initials}
              </span>
              <span className="text-xs text-gray-500">
                {new Date(c.created_at).toLocaleString()}
              </span>
            </div>
            <p className="text-gray-700 whitespace-pre-wrap">{c.body}</p>
          </div>
          {c.is_owner && (
            <button
              onClick={() => deleteComment(c.id)}
              className="text-xs text-red-600 hover:underline ml-2"
            >
              Löschen
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
